import { call, put, takeLatest } from 'redux-saga/effects';
import i18n from '../locale';
import { getCameraStream, getDeviceList } from '../utils/device';
import {
  SET_CAMERA_STREAM_REQUEST,
  SET_CAMERA_STREAM_SUCCESS,
  ENUMERATE_DEVICES_REQUEST,
  ENUMERATE_DEVICES_SUCCESS
} from '../redux/action/types';
import { defaultInfoModalState } from '../redux/reducer/types';

function* fetchStream() {
  try {
    // first of all handle prices data with id's
    const stream = yield call(() => getCameraStream());
    // make stream available to console
    window.stream = stream;

    yield put({
      type: SET_CAMERA_STREAM_SUCCESS,
      data: {
        stream,
        videoDevices: null
      }
    });
  } catch (e) {
    if (e.name === 'NotFoundError') {
      yield put({
        type: SET_CAMERA_STREAM_SUCCESS,
        data: false
      });
    }
    // do we need this?
    else {
      const infoModalContent = defaultInfoModalState;
      infoModalContent.isOpen = true;
      infoModalContent.type = 'error';
      infoModalContent.message = i18n.t('components:modal.error.message');
    }
  }
}

function* enumerateDevices() {
  try {
    const devices = yield call(() => getDeviceList());
    const videoInputs = devices.filter(item => item.kind === 'videoinput');

    // yaay !! we have video devices
    if (videoInputs.length >= 1) {
      yield put({
        type: ENUMERATE_DEVICES_SUCCESS,
        data: videoInputs
      });
    }
  } catch (e) {
    console.log('Error at Device Saga / Enumerate devices', e);
  }
}

export default function* initDeviceSaga() {
  yield takeLatest(SET_CAMERA_STREAM_REQUEST, data => fetchStream(data.data));
  yield takeLatest(ENUMERATE_DEVICES_REQUEST, data =>
    enumerateDevices(data.data)
  );
}
